// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__3ZIYs","active":"Uploader_active__2W8No"};